/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ADSEC){
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';

	// <RECRUIT TOP>働く環境スライダー
	const officeSlider = () => {
		$('.js-office-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [{
				breakpoint: 1025,
				settings: {
					arrows: false,
				}
			}]
		});
	}

	// <RECRUIT TOP>イベントスライダー
	const eventSliderSetting = () =>{
		let width = $(window).width();
		if(width <= 1024) {
			$('.js-event-slider').not('.slick-initialized').slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 1,
				arrows: false,
				dots: true,
			});
		} else {
			$('.js-event-slider.slick-initialized').slick('unslick');
		}
	}

	// <インタビューページ>入社後のキャリアステップ スライド
	const stepSliderSetting = () =>{

		let width = $(window).width();
		if(width <= 1024) {
			$('.js-step-slide').not('.slick-initialized').slick({
				infinite: false,
				speed: 1000,
				autoplay: false,
				slidesToShow: 2,
				arrows: false,
				dots: false,
			});

			$('.js-step-slide.slick-slider').one('touchmove', () => {
				$('.recruit-staff-step-innerWrap .__swipe').addClass('is-hidden');
			});
		} else {
			$('.js-step-slide.slick-initialized').slick('unslick');
		}
	}
	

	// ===================================================================
	if($('.js-office-slider').length) {
		officeSlider();
	}
	if($('.js-event-slider').length) {
		eventSliderSetting();

		$(window).resize(function(){
			eventSliderSetting();
		});
	}
	if($('.js-step-slide').length) {
		stepSliderSetting();

		$(window).resize(function(){
			stepSliderSetting();
		});
	}

})(window.jQuery, window.ADSEC);
